import React from 'react';
import ModerationQueueSection from '../../../sections/AdminDashboard/Moderation/ModerationQueue';

const ModerationQueue = () => {
  return <ModerationQueueSection />;
};

export default ModerationQueue;

